import React from 'react';
import { Form } from 'antd';
import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import CustomerRadioInput from '../../../../../inputs/customerRadioInput/CustomerRadioInput';
import useTranslation from '../../../../../../hooks/translation/useTranslation';
import { bankTypesToCountry } from '../../../../../../../utils/constants';
import CountryBankOptions from './components/CountryBankOptions';

function PaymentMethod() {
  const { paymentCards, paymentMethodForm } = useBooking();
  const { configInfo, trans } = useTranslation();

  const paymentMethodLabel = (card) => (
    <div className="flex gap-[10px] items-center w-full">
      <div className="w-[35px] h-[25px] bg-[#1834CD] rounded-[4px]" />
      {card?.mask}
    </div>
  );

  const paymentBankTypes = bankTypesToCountry?.[configInfo?.countryCode] || [];
  const paymentBankValue = paymentBankTypes?.length > 1 ? Form.useWatch('payment_bank', paymentMethodForm) : paymentBankTypes?.[0]?.name;

  const currentPaymentBank = paymentBankTypes
    ?.find((type) => type.name === paymentBankValue);

  const paymentCardOptions = paymentCards
    ?.filter((card) => (paymentBankTypes?.length
      ? currentPaymentBank?.name === card?.bank_type : paymentBankTypes[0] === card?.bank_type))
    ?.map((card) => ({
      label: paymentMethodLabel(card),
      visible: true,
      value: card?.id,
    }));

  paymentCardOptions?.push({
    label: trans('new_card'),
    visible: true,
    value: null,
  });

  return (
    <Form layout="vertical" className="flex flex-col gap-5" form={paymentMethodForm}>
      <h3 className="font-big-bold">
        {trans('payment_method')}
      </h3>
      <div className="w-full h-[1px] bg-gray-semi-light-gr" />
      <CountryBankOptions />
      {currentPaymentBank?.type === 'card_choose' && (
      <>
        <div className="w-full h-[1px] bg-gray-semi-light-gr" />
        <CustomerRadioInput
          name="payment_card"
          groupClassName="flex flex-col gap-5"
          options={paymentCardOptions || []}
        />
      </>
      )}
    </Form>
  );
}

export default PaymentMethod;
